/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class SalaryPermissionKey {
  static readonly OVERVIEW = 'salary/permission/overview';
}
